import React, { useEffect } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import { Link } from "react-router-dom";
import Brands1 from "../brands/Brands1";
import Clientspeak from "../testimonials/Clientspeak";
import { FaPlay } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";

const Healthcare = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <BreadcrumbsHeader 
        title="Health & Medical" 
        backgroundImage="/images/breadcrumbs/healthcare-Medical-Header-Image-new-new.jpeg" 
      />

  <section className="section-about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="b-mod-heading text-center">
              <p className="first-heading font-secondary wow fadeInDown">
                Robust &amp; Reliable Tech and Digital Marketing Solutions for
              </p>
              <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
                <strong>Healthcare &amp; Medical Industry</strong>
              </h2>
              <p className="second-heading font-additional">
                Technology &amp; digital marketing has become the vital aspect
                of the healthcare &amp; medical industry. Be it ever automation,
                healthcare facility management or targeting &amp; managing the
                people, everything is possible via technology &amp; digital aid.
                <br />
                Serving as a technology &amp; digital partner of eminent
                hospitals, doctors and healthcare professionals, we have the
                years of rich experience in delivering edge cutting software and
                digital solutions &amp; services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

<section className="section-about">
  <div className="container-bg-additional relative clearfix">
    <div className="b-services-bg-filter customBgColor"></div>
    <div className="b-featured-services">
      <div className="container">
        <div className="row">
          {/* Left Content */}
          <div className="col-xs-12 col-sm-7 col-md-6 col-lg-7">
            <div
              className="featured-services-left wow slideInLeft"
              style={{ visibility: "visible", animationName: "slideInLeft" }}
            >
              <div className="b-f-s-info offer">
                <h3 className="f-s-title">
                  Our Offerings For <br />
                  Healthcare &amp; Medical
                </h3>
                <p>
                  We have wide range of web, cloud and digital marketing
                  solutions &amp; services for hospitals, doctors and other
                  healthcare entities.
                </p>
                <a
                  href="/contact"
                  className="btn btn-default-arrow btn-sm"
                >
                  <FaArrowRight /> 
                  get in touch
                </a>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-xs-11 col-sm-5 col-md-5 col-lg-5">
            <div
              className="bank featured-services-right wow fadeIn"
              style={{ visibility: "visible", animationName: "fadeIn" }}
            >
              <div className="b-work-steps">
                {/* Item 1 */}
                <div className="b-services-item">
                  <div className="services-icon work-active">
                    <div className="circle-0">
                      <div className="circle-1">
                        <div className="circle-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                      <span className="customColor">1.</span> Application
                      Services
                    </h6>
                    <p>
                      Designing cloud based web applications for Healthcare &amp;
                      medical industry.
                    </p>
                  </div>
                </div>

                {/* Item 2 */}
                <div className="b-services-item">
                  <div className="services-icon">
                    <div className="circle-0">
                      <div className="circle-1">
                        <div className="circle-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                      <span className="customColor">2.</span> Mobility Services
                    </h6>
                    <p>
                      Enabling to grow smart with official mobile app for
                      Healthcare &amp; medical industry.
                    </p>
                  </div>
                </div>

                {/* Item 3 */}
                <div className="b-services-item">
                  <div className="services-icon">
                    <div className="circle-0">
                      <div className="circle-1">
                        <div className="circle-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                      <span className="customColor">3.</span> Cloud
                      Infrastructure Services
                    </h6>
                    <p>
                      Providing &amp; managing end-to-end cloud infra for the
                      cloud &amp; mobile apps.
                    </p>
                  </div>
                </div>

                {/* Item 4 */}
                <div className="b-services-item">
                  <div className="services-icon">
                    <div className="circle-0">
                      <div className="circle-1">
                        <div className="circle-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                      <span className="customColor">4.</span> Business Process
                      Services
                    </h6>
                    <p>
                      Managing overall customer relationship &amp; support
                      process.
                    </p>
                  </div>
                </div>

                {/* Item 5 */}
                <div className="b-services-item">
                  <div className="services-icon">
                    <div className="circle-0">
                      <div className="circle-1">
                        <div className="circle-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                      <span className="customColor">5.</span> Digitalisation &amp;
                      Technology Automation
                    </h6>
                    <p>
                      Overall industry digitisation and enhancement via tech
                      automation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Right */}
        </div>
      </div>
    </div>
  </div>
</section>


    <section className="section-about">
      <div className="container">
        <div className="b-home-video-block">
          <div className="container-fluid">
            {/* Left Side (Video) */}
            <div className="col-xs-12 col-sm-5 col-md-6 col-lg-6 left-side wow slideInLeft">
              <div className="b-video-holder">
                <a
                  className="video-image playVideo"
                  href="https://www.youtube.com/watch?v=eq3jsESwuzQ&feature=youtu.be"
                  data-toggle="lightbox"
                  data-title="Why Choose ISOLS Group"
                >
                  <FaPlay className="demo-icon play-icon" />
                  <span className="video-title">play the video</span>
                </a>
              </div>
            </div>

            {/* Right Side (Content) */}
            <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6 right-side wow slideInRight">
              <div className="content">
                <div className="b-mod-heading">
                  <p className="first-heading customPseudoElBg font-secondary">
                    Why Choose
                  </p>
                  <h2 className="heading-line line-right">
                    <strong>ISOLS?</strong>
                  </h2>
                  <div className="b-text">
                    <p>
                      Designing &amp; implementing industry specific technology
                      and digital solution for industry automation &amp;
                      enhancement is our forte and we do it very passionately.
                      The solutions that we design are strongly backed by strong
                      thorough research, study of industry challenges and pilot
                      implementation of the solution.
                    </p>
                  </div>
                  <a
                    href="/about-isolsgroup"
                    className="btn btn-default-arrow"
                  >
                    <FaArrowRight className="fa fa-arrow-right" aria-hidden="true" />
                    know more about ISOLS Group
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Clientspeak />
    <Brands1 />
  </div>
);
};

export default Healthcare;
